<template>
  <!-- A native disabled fieldset is what makes this tab genuinely read-only for the sterilised
       "Tax Inquiry - view only" persona: the browser refuses focus, typing and clicks on every
       control inside it, so no field has to be found and flagged one at a time, and a field
       added later is covered automatically. It replaces the root <div> rather than wrapping it
       so the markup below keeps its indentation. -->
      <fieldset class="tax-general-details-fieldset" :disabled="isTaxViewOnly">
        <v-row class="pt-2">
          <v-col cols="9" class="d-flex flex-row pt-0 pb-0">
             <CommonDropDowns class="mt-n3 mr-1" :isItTaxType=true
            @change="dataFromCommonDropDowns" :taxTypeValue="editedItem.taxType"
            :taxTypeRequired="true" />
            <CommonDropDowns class="mt-n3 mr-1" :isItTaxYearWithoutAllYears=true
            @change="dataFromCommonDropDowns" :taxYearValue="editedItem.taxYear"
            :isTaxYearWithoutAllDisabled="true" />
            <v-text-field class="input-text-size pt-0 pb-0 mr-2" @click="onTaxIdClick()"
             v-model.number="editedItem.taxId" label="Tax ID" :rules="isTaxOmitSaExits"
             :readonly="!!editedItem._id" :tabindex="editedItem._id ? -1 : 0">
            </v-text-field>
            <v-text-field class="input-text-size pt-0 pb-0 mr-2" label="Base ID"
            v-model.number="editedItem.baseId" :rules="rules">
            </v-text-field>
            <v-text-field class="input-text-size pt-0 pb-0"
             :value="editedItem.ownerId" label="Owner ID" readonly tabindex="-1" />
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size pt-0 pb-0" v-model="editedItem.propertyOrParcelId"
              label="Property/Parcel ID" :rules="pIdRules" :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
              @blur="formatToPidWithDashes('propertyOrParcelId')"
              @focus="formatToPidWith('propertyOrParcelId'), $event.target.select()"
              v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-0">
          <v-col cols="3" class="pt-0 pb-0 pr-1">
            <v-textarea class="input-text-size pt-0 pb-0 dec-line-height"
             v-model="editedItem.legalDesc" outlined rows="7"
             label="Legal Description (F9 Copy to Clipboard)"
             :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
             v-textAreaUppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="5" class="pt-0 pb-0 px-1">
            <v-row class="flex-nowrap ma-0">
              <v-col cols="7" class="pt-0 pb-0 pr-1 pl-0">
                <v-textarea class="input-text-size pa-0 dec-line-height" outlined rows="7"
                 label="Owner Information (F10 Copy to Clipboard)"
                 :value="ownerInfo" readonly tabindex="-1" />
              </v-col>
              <v-col cols="5" class="pt-0 pb-0 pl-1 pr-0">
                <!-- <label class="v-label theme--light">Status</label> -->
                <div class="status-codes-wrapper input-text-size pa-0 dec-line-height">
                  <div
                    class="status-codes-outlined"
                      style="border: 1px solid rgba(0,0,0,0.38);
                      border-radius: 4px; min-height: 60px; max-height: 110px;
                      padding: 12px; overflow-y: auto;"
                  >
                    <div
                      v-for="(line, idx) in showStatusCodes"
                      :key="idx"
                      :class="['status-code-line',
                       line.alertOnTaxRecord ? 'alert-on-tax-record' : '']"
                      style="color: red;"
                    >
                      {{ line.label }}
                    </div>
                    <div v-if="!showStatusCodes.length"
                    class="status-code-line" style="color: rgba(0,0,0,0.38);">
                      &nbsp;
                    </div>
                  </div>
                  <div v-if="canActOnTaxRecord" class="d-flex justify-end mt-3" style="margin-top: -28px;">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="primary" v-bind="attrs" v-on="on" @click="statusDialogFunc">
                          {{ icons.mdiListStatus }}
                        </v-icon>
                      </template>
                      <span>Add Status</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-dialog
                v-model="statusDialog"
                max-width="500px"
                persistent
              >
                <v-card>
                  <v-card-title>
                    Select the Status
                  </v-card-title>
                  <v-card-text>
                    <CommonDropDowns :isItstaCode=true @change="dataFromCommonDropDowns"
                    :staCodeValue="selectedStatusCodes" :selectMultiple="true"/>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary" text @click="upsertItem()">
                      Save
                    </v-btn>
                    <v-btn
                      color="primary"
                      text
                      @click="statusDialog=false"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
          </v-col>
          <!-- No comments anywhere for the view-only persona - not even the summary card. -->
          <v-col v-if="canActOnTaxRecord" cols="4" class="pt-0 pb-0 pl-1">
            <v-card class="px-2 comments-card">

    <v-card-title class="input-text-size pa-0" >Comments</v-card-title>
    <v-card-text v-if="commentData.length===0">
      <p class="input-text-size pa-0 ma-n3 clamp-2-lines "> No comments available </p>
    </v-card-text>
    <v-card-text
     v-for="(comment, index) in commentData" :key="index">
       <p class="input-text-size pa-0 ma-n3 clamp-2-lines "
       :style="{ color: comment.isItCategorySeven ? '#0051D4' : '' }">
       {{  getCommentText(comment) }}</p>
    </v-card-text>
  </v-card>
          </v-col>
        </v-row>
        <v-row class="mt-0 mb-n9">
          <v-col cols="3">
            <CommonDropDowns :isItAdditions=true class="pa-0 mt-n3"
              :isAdditionsDisabled="checkTheUserIsTaxAdmin"
              @change="dataFromCommonDropDowns" :taxAdditionValue="editedItem.addition"/>
          </v-col>
          <v-col cols="2">
            <CommonDropDowns class="mt-n3 mr-1" :isItTaxDistrict=true
            @change="dataFromCommonDropDowns" :taxDistrictValue="editedItem.schoolDistrict"
            :isItTaxDistrictRequired="true" :isTaxDistrictDisabled="checkToDisableTaxDist"
            :taxDistrictTooltip="checkToDisableTaxDist ? taxDistrictDisabledReason : ''"/>
          </v-col>
          <v-col cols="1">
            <v-text-field class="input-text-size pa-0" label="Tax Rate"
            :value="amountFormat(taxRateTaxInquiry)" readonly tabindex="-1"/>
          </v-col>
          <v-col cols="2" class="mt-n3">
            <CommonDropDowns :isItMtgCode=true @change="dataFromCommonDropDowns"
            :mtgCodeValue="editedItem.mtgCode"/>
          </v-col>
          <v-col cols="2">
            <!-- A bare `disabled` used to sit on this tag. CommonDropDowns declares no such
                 prop, so Vue put it on the component's root div as a dead HTML attribute - a
                 div cannot be disabled and it never locked anything. The real lock is
                 :isTaxDistrictDisabled below. Parked here rather than dropped silently. -->
            <CommonDropDowns class="mt-n3 mr-1" :isItTaxDistrict=true
            taxDistrictLabelOverride="Original Tax District"
            taxDistrictNameOverride="originalTaxDistrict"
            @change="dataFromCommonDropDowns" :taxDistrictValue="editedItem.originalTaxDistrict"
             :isTaxDistrictDisabled="checkToDisableTaxDist"/>
          </v-col>
          <v-col cols="1">
            <v-text-field class="input-text-size pa-0" :label="loanLabel"
            v-model="editedItem.loanNumber" />
          </v-col>
          <v-col cols="1">
              <ClarionDateControl class="input-text-size mt-n3" :isToggle="false"
              v-model="editedItem.penaltyStartDate" label="Penalty Start Date"
              @blurred="penaltyStartDateOnBlurred" />
            </v-col>
        </v-row>
        <v-row class="mt-0 mb-n9">
          <v-col cols="1">
            <v-text-field class="input-text-size pa-0" label="Number"
            v-model.number="editedItem.situsStreetNumber" :rules="rulesForNumerics"
            :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0" />
          </v-col>
          <v-col cols="1">
            <v-text-field class="input-text-size pa-0" label="Direction"
            v-model="editedItem.situsStreetDirection" :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
            v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="2">
            <v-text-field class="input-text-size pa-0" label="Street Name"
            v-model="editedItem.situsStreetName" :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
            v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="1">
            <v-text-field class="input-text-size pa-0" label="Type"
            v-model="editedItem.situsStreetType" :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
            v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="1">
            <v-text-field class="input-text-size pa-0" label="Suffix"
            v-model="editedItem.situsSuffix" :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
            v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="2">
            <v-text-field class="input-text-size pa-0" label="Town"
            v-model="editedItem.situsTown" :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
            v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="1">
            <v-text-field class="input-text-size pa-0" label="Certificate"
            v-model.number="editedItem.certificate" type="number"
            :readonly="certificateFieldLocked" :tabindex="certificateFieldLocked ? -1 : 0"
            v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="1">
            <v-text-field class="input-text-size pa-0" label="Invoice No."
            v-model="editedItem.invoiceNumber"
            v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="2">
            <v-text-field class="input-text-size pa-0 mb-n2" label="Deed Bk/Pg"
            v-model="editedItem.deedBkOrPg"
            v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
        </v-row>
        <v-row class="mt-1 mb-n0">
          <v-col cols="6">
            <v-row class="mt-n7">
              <v-col cols="5">
                <v-text-field class="input-text-size" label="Situs"
                :value="situsAddressFunc()" tabindex="-1" readonly />
              </v-col>
              <v-col cols="2">
                <v-text-field class="input-text-size" label="Acres"
                :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
                v-model.number="editedItem.acres" :rules="rulesForNumerics" />
              </v-col>
              <v-col cols="2">
                <v-text-field class="input-text-size " label="Lots"
                :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
                v-model.number="editedItem.lots" :rules="rulesForNumerics" />
              </v-col>
              <v-col cols="3">
                <v-text-field class="input-text-size" label="Exemptions"
                 :value="homesteadDisplay" tabindex="-1" readonly />
              </v-col>
              <v-col cols="12">
                <v-row class="mt-n12">
                  <v-col cols="2">
                    <v-text-field class="input-text-size pa-0" label="Section"
                    v-model="editedItem.section" :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
                    v-uppercase=globalSettingItem.conEverythingToCaps />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field class="input-text-size pa-0" label="Township"
                    v-model="editedItem.townShip" :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
                    v-uppercase=globalSettingItem.conEverythingToCaps />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field class="input-text-size pa-0" label="Range"
                    v-model="editedItem.range" :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
                    v-uppercase=globalSettingItem.conEverythingToCaps />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field class="input-text-size pa-0" label="QSec"
                    :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
                    v-model.number="editedItem.qSec" :rules="rulesForNumerics" />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field class="input-text-size pa-0" label="Lot"
                    :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
                    v-model.number="editedItem.lot" :rules="rulesForNumerics" />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field class="input-text-size pa-0" label="Block"
                    :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
                    v-model="editedItem.block" v-uppercase=globalSettingItem.conEverythingToCaps />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="display-relative">
            <v-btn
          v-if="canActOnTaxRecord"
          color="primary"
          fab icon small
          absolute
          top
          right
          class="mt-7 mr-n8 tax-general-details-form-fees-plus-btn-fees-plus-btn"
          id="taxGeneralDetailsFormFeesPlusBtn"
          :disabled="isItExemptManufacturing()"
          @click="openConfirmPopUp"
        >
          <v-icon small>
            {{icons.mdiPlus}}
          </v-icon>
        </v-btn>
            <TaxRollFeesTable ref="newItem" :selectedRowItem="editedItem"
            :mainBaseCrudKey="baseCrudKey" :baseCrudKeyForFeeList="baseCrudKeyForFeeList"
            @delinquentRefresh="$emit('delinquentRefresh')"/>
          </v-col>
        </v-row>
        <v-row class="mt-n0">
          <v-col cols="2" class="pt-0 pb-0">
            <v-row class="pt-0 pb-0 mt-n5">
              <v-col cols="8">
                <label class="input-text-size">Land : </label>
                </v-col>
                <v-col cols="4" class="text-right" >
                  <label class="input-text-size">{{ (editedItem.land) }}</label>
                </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 mt-n5">
              <v-col cols="8">
                <label class="input-text-size">Improvements : </label>
                </v-col>
                <v-col cols="4" class="text-right">
                  <label class="input-text-size">{{ (editedItem.improvements) }}</label>
                </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 mt-n5">
              <v-col cols="8">
                <label class="input-text-size">Mobile Home : </label>
                </v-col>
                <v-col cols="4" class="text-right">
                  <label class="input-text-size">{{ (editedItem.mobileHome) }}</label>
                </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 mt-n5">
              <v-col cols="8">
                <label class="input-text-size">Assessor Penalty : </label>
                </v-col>
                <v-col cols="4" class="text-right">
                  <label class="input-text-size">
                    {{ (editedItem.assessorPenalty) }}</label>
                </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 mt-n5">
              <v-col cols="8">
                <label class="input-text-size">Exemptions : </label>
                </v-col>
                <v-col cols="4" class="text-right">
                  <label class="input-text-size">{{ (editedItem.exemptions) }}</label>
                </v-col>
            </v-row>
            <v-row align='end' class="pt-0 pb-0 mt-n5  ">
              <v-col cols="8">
                <label class="input-text-size">Net Assessed Value : </label>
                </v-col>
                <v-col cols="4" class="text-right">
                  <label class="input-text-size">{{ (netAssesedValue)}}</label>
                </v-col>
            </v-row>
          </v-col>

          <v-col cols="6" class="pt-0 pb-0">
            <GeneralDetailsPayments getHeight="150" :selItem="editedItem"
             :baseCrudKeyOfMainParent="baseCrudKey"
             :baseCrudKeyForFeeList="baseCrudKeyForFeeList" />
          </v-col>

          <v-col cols="2" class="pt-0 pb-0">
            <v-row class="pt-0 pb-0 mt-n3">
              <v-col cols="7">
                <label
                  class="input-text-size tax-general-details-form-original-tax-label"
                  id="taxGeneralDetailsFormOriginalTaxLabel"
                >
                  Orig. tax :
                </label>
              </v-col>
              <v-col cols="5" class="text-right">
                <label
                  class="input-text-size tax-general-details-form-original-tax-value"
                  id="taxGeneralDetailsFormOriginalTaxValue"
                >
                  {{ amountFormat(originalTaxCacl) }}
                </label>
              </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 mt-n5">
              <v-col cols="7">
                <label
                  class="input-text-size tax-general-details-form-adjustments-label"
                  id="taxGeneralDetailsFormAdjustmentsLabel"
                >
                  Adjustments :
                </label>
              </v-col>
              <v-col cols="5" class="text-right">
                <label
                  class="input-text-size tax-general-details-form-adjustments-value"
                  id="taxGeneralDetailsFormAdjustmentsValue"
                >
                  {{ amountFormat(editedItem.adjustments) }}
                </label>
              </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 mt-n5">
              <v-col cols="7">
                <label
                  class="input-text-size tax-general-details-form-tax-amount-label"
                  id="taxGeneralDetailsFormTaxAmountLabel"
                >Tax Amount : </label>
              </v-col>
              <v-col cols="5" class="text-right">
                <label
                  class="input-text-size tax-general-details-form-tax-amount-value"
                  id="taxGeneralDetailsFormTaxAmountValue"
                >
                  {{ amountFormat(editedItem.totalTax) }}
                </label>
              </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 mt-n5">
              <v-col cols="7">
                <label class="input-text-size tax-general-details-form-tax-paid-label"
                id="taxGeneralDetailsFormTaxPaidLabel">Tax Paid : </label>
              </v-col>
              <v-col cols="5" class="text-right">
                <label
                  class="input-text-size tax-general-details-form-tax-paid-value"
                  id="taxGeneralDetailsFormTaxPaidValue"
                >
                  {{ amountFormat(editedItem.totalPaid) }}
                </label>
              </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 mt-n5">
              <v-col cols="7">
                <label class="input-text-size tax-general-details-form-tax-due-label"
                id="taxGeneralDetailsFormTaxDueLabel">Tax Due : </label>
              </v-col>
              <v-col cols="5" class="text-right">
                <label
                  class="input-text-size tax-general-details-form-tax-due-value"
                  id="taxGeneralDetailsFormTaxDueValue"
                >
                  {{ amountFormat(editedItem.totalDue) }}
                </label>
              </v-col>
            </v-row>
            <v-row class="pt-0 pb-0 mt-n2">
             <v-btn class="input-text-size" text color="blue darken-1" v-if="checkIfItsTmAdmin"
              @click="handleFixAmounts">Fix Amounts</v-btn>
            </v-row>
          </v-col>

          <v-col cols="2" class="pt-0 pb-0 mb-n2 tax-general-details-form-total-fees-col"
          id="taxGeneralDetailsFormTotalFeesCol">
            <span class="d-flex justify-space-between total-fees-row" id="totalFeesRow">
              <label
                class="input-text-size tax-general-details-form-total-fees-label"
                id="taxGeneralDetailsFormTotalFeesLabel"
              >Total Fees :</label>
              <label
                class="input-text-size tax-general-details-form-total-fees-value"
                id="taxGeneralDetailsFormTotalFeesValue"
              >
                {{ amountFormat(editedItem.totalFee) }}
              </label>
            </span>

            <ClarionDateControl
              class="input-text-size mt-n2 mb-n2 tax-general-details-form-penalty-date-control"
              id="taxGeneralDetailsFormPenaltyDateControl"
              @input="penaltyCaclFunc"
              :isToggle="false"
              :penalty-change-day="Number(taxSettingItem.penaltyDate) || null"
              v-model="editedItem.penaltyDateValue"
              label="Penalty Date"
            />

            <span class="d-flex justify-space-between tax-general-details-form-penalty-rate-row"
            id="taxGeneralDetailsFormPenaltyRateRow">
              <label
                class="input-text-size tax-general-details-form-penalty-rate-label"
                id="taxGeneralDetailsFormPenaltyRateLabel"
              >Penalty :</label>
              <label class="input-text-size tax-general-details-form-penalty-rate-value"
              id="taxGeneralDetailsFormPenaltyRateValue">
                @ {{ this.editedItem.getPenRateWithMonths || 0 }}%
              </label>
            </span>

            <span class="d-flex justify-space-between tax-general-details-form-penalty-amount-row"
             id="taxGeneralDetailsFormPenaltyAmountRow">
              <label
                class="input-text-size tax-general-details-form-penalty-amount-label"
                id="taxGeneralDetailsFormPenaltyAmountLabel"
              >
                Penalty Amount :
              </label>
              <label
                class="input-text-size tax-general-details-form-penalty-amount-value"
                id="taxGeneralDetailsFormPenaltyAmountValue"
              >
                {{ amountFormat(editedItem.penaltyAmount) }}
              </label>
            </span>

            <span class="d-flex justify-space-between tax-general-details-form-total-due-row"
             id="taxGeneralDetailsFormTotalDueRow">
              <h4 class="tax-general-details-form-total-due-label"
              id="taxGeneralDetailsFormTotalDueLabel">Total Due :</h4>
              <h4 class="tax-general-details-form-total-due-value"
              id="taxGeneralDetailsFormTotalDueValue">
                {{ amountFormat(editedItem.feesAndPen) }}
              </h4>
            </span>
          </v-col>
        </v-row>
      <CommonPopUp v-model="showOrHidePopUp" flashType="info">
        <template v-slot:customsLabelOrInfo>
        <p style="white-space: pre;">{{ messageText }}</p>
      </template>
        <template v-slot:[`customsButtonsForPopUp`]="{}">
          <v-btn :class="`input-text-size`" text color="blue darken-1"
          @click="openConfirmPopUp('continue')">Continue</v-btn>
          <v-btn :class="`input-text-size`" text color="blue darken-1"
          @click="openConfirmPopUp('Cancel')">Cancel</v-btn>
        </template>
      </CommonPopUp>
      </fieldset>
</template>

<script>
import {
  mdiListStatus,
  mdiPlus,
} from '@mdi/js';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import TaxRollFeesTable from './TaxRollFeesTable.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import GeneralDetailsPayments from '../taxrollSearch/SubComponents/GeneralDetailsPayments.vue';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import CommonPopUp from '../../common-utils/CommonPopUp.vue';
import {
  amountToNumber, amountFormat, pIdFormat,
} from '../../../../util/shared/vue-global';
import { exemptManufacturingStatusCode, penaltyCalculation, commonFuncForConsolidateView } from '../../common-utils/tax-common.util';
import { REGEX_VALIDATION, SEARCH_DEBOUNCE_TIMER } from '../../common-utils/constants';
import { mergeCodeWithName, taxCommonPostProcessTrans, taxFeeCheckWitheEfectiveDate } from '../../common-utils/CommonTaxFunctionalities';
import { toIsoDate, toShortDate } from '../../../../util/shared/tmc-global';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import PenaltyStartDateSnap from '../../common-utils/PenaltyStartDateSnap.mixin.vue';
import { TaxViewOnlyMixin } from '../TaxInquiryUtils/taxViewOnly.mixin';
import { getTulsaSitusSuffix, isTulsa } from '../../../../util/shared/county-specific.config';
import '../../../../assets/style.css';
import { authRoles } from '../../../../router/roleGroups';
import { isAuthorised } from '../../../../store/auth/token';

export default {
  mixins: [GlobalToCaps, PenaltyStartDateSnap, TaxViewOnlyMixin],
  props: {
    baseCrudKey: {
      type: String,
      default: 'TaxInquiryDialog',
    },
    baseCrudKeyForFeeList: {
      type: String,
      default: 'baseCrudKeyForFeeList',
    },
    feeListBasedInIds: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    TaxRollFeesTable,
    ClarionDateControl,
    GeneralDetailsPayments,
    CommonDropDowns,
    CommonPopUp,
  },
  mounted() {
    if (!this.editedItem.penaltyDateValue) {
      this.editedItem.penaltyDateValue = toShortDate(new Date());
    }
    this.penaltyCaclFunc(this.editedItem.penaltyDateValue);
  },
  data() {
    return {
      statusDialog: false,
      showOrHidePopUp: false,
      messageText: 'This record is already paid, do you still want to continue?',
      selectedStatusCodes: [],
      icons: {
        mdiListStatus,
        mdiPlus,
      },
      delayTimerId: null,
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item', 'items', 'criteria',
    ]),
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapState({
      taxStatusCodes: (state) => state.shared.taxStatusCodesShared.taxStatusCodes,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      penDate: (state) => state.tax.taxInquires.penaltyDate,
      TaxTypeEnum: (state) => state.enums.TaxTypeEnum,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      taxRateTaxInquiry: (state) => state.tax.taxInquires.taxRateTaxInquiry,
      taxStatusCodesSharedHighlight: (state) => state.base.crud.items.taxStatusCodesSharedHighlight,

    }),
    ...mapGetters('auth/token', [
      'isTaxAdminAccessible',
      'isDelinquentTaxAccessible',
    ]),
    rules() {
      return [
        (v) => {
          if (v) return REGEX_VALIDATION.onlyNumWithSomeSpeChar.test(v) || 'Numerics only';
          return !!v || 'Required.';
        },
        () => true,
      ];
    },
    isTaxOmitSaExits() {
      return [
        () => {
          if (!this.taxSettingItem.omittedProperties && !this.editedItem._id) {
            return 'Required Omitted Properties from Tax-setting';
          }
          return true;
        },
      ];
    },
    rulesForNumerics() {
      return [
        (v) => {
          if (v) return REGEX_VALIDATION.onlyNumWithSomeSpeChar.test(v) || 'Numerics only';
          return true;
        },
        () => true,
      ];
    },
    pIdRules() {
      return [
        (v) => {
          if (this.editedItem.taxType && (this.editedItem.taxType).toUpperCase() === 'R') return !!v || 'Required.';
          return true;
        },
      ];
    },
    checkTheUserIsTaxAdmin() {
      const userRole = this.isTaxAdminAccessible;
      return (!userRole && !!this.editedItem._id);
    },
    // The Certificate number secures a tax lien. An Assessor clerical correction to the name or
    // legal voids that lien, and Delinquent Tax staff have to clear the certificate and restart
    // the lien process - so they need this one field, which the tax-admin gate above denies them.
    // Deliberately separate from checkTheUserIsTaxAdmin: that computed gates 17 other fields on
    // this form and must keep its narrower tax-admin-only rule.
    certificateFieldLocked() {
      const canEditCertificate = this.isTaxAdminAccessible || this.isDelinquentTaxAccessible;
      return (!canEditCertificate && !!this.editedItem._id);
    },
    editedItem: {
      get() {
        const itemData = this.item(this.baseCrudKey);
        // currenlty while importing data we are getting 0 as status code . but
        // business team don't want to show so we just remove
        if (itemData.statusCode && itemData.statusCode.length > 0) {
          if (itemData.statusCode[0] === 0) {
            delete itemData.statusCode[0];
          }
        }
        return itemData;
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    commentData() {
      return this.items('taxRollComments') || [];
    },
    netAssesedValue() {
      return amountToNumber(this.editedItem.land) + amountToNumber(this.editedItem.improvements)
      + amountToNumber(this.editedItem.mobileHome) + amountToNumber(this.editedItem.assessorPenalty)
      - amountToNumber(this.editedItem.exemptions);
    },
    originalTaxCacl() {
      // need to update this logic because when adjustment is -x then
      // need to perform +x and for + need to perform -x
      // eslint-disable-next-line max-len
      return amountToNumber(this.editedItem.totalTax) - (amountToNumber(this.editedItem.adjustments));
    },
    taxTypeDropDownFunc() {
      const updatedItems = mergeCodeWithName(this.TaxTypeEnum, 'name', 'description', false);
      return updatedItems;
    },
    homesteadDisplay() {
      const val = this.editedItem.homestead;
      if (Array.isArray(val)) return val.join(', ');
      return val || '';
    },
    ownerInfo() {
      return commonFuncForConsolidateView(this.editedItem);
    },
    checkToDisableTaxDist() {
      // Changing the district moves the parcel's levy but leaves already-posted
      // payments/adjustments stamped with the OLD district, throwing both districts
      // out of balance on the tax roll summary. Only allow the change once the
      // record is fully reversed (totalTax = 0 AND totalPaid = 0) - matching the
      // server-side guard in taxTransaction.util.js (assertSchoolDistrictChangeAllowed).
      if (amountToNumber(this.editedItem.totalTax)) return true;
      if (amountToNumber(this.editedItem.totalPaid)) return true;
      return false;
    },
    taxDistrictDisabledReason() {
      const totalTax = amountToNumber(this.editedItem.totalTax);
      const totalPaid = amountToNumber(this.editedItem.totalPaid);
      return 'Cannot change the school district while this record has tax or payments '
        + `(totalTax=${totalTax}, totalPaid=${totalPaid}). Reverse the payments and adjust `
        + 'the tax to 0 before changing the district.';
    },
    convertArrToObjects() {
      return Object.fromEntries((this.taxStatusCodes || []).map((ft) => [ft.value, ft.name]));
    },
    showStatusCodes() {
      const getStatusCode = (this.editedItem.statusCode || [])
        .filter((ft) => ft !== null && ft !== undefined);
      const list = (this.taxStatusCodesSharedHighlight || []);
      const codeToInfo = list.reduce((acc, t) => {
        const code = t.statusCode != null ? t.statusCode : t.value;
        if (code == null) return acc;
        const name = t.description || t.name || String(code);
        acc[code] = { label: `${code} - ${name}`, alertOnTaxRecord: !!t.alertOnTaxRecord };
        return acc;
      }, {});
      return getStatusCode.map((code) => ({
        label: codeToInfo[code]
          ? codeToInfo[code].label
          : (this.convertArrToObjects[code] || String(code)),
        // "Alert on tax record" codes pulse here to draw attention. Codes without the
        // flag - and every code in the search result grids - render exactly as before.
        alertOnTaxRecord: codeToInfo[code] ? codeToInfo[code].alertOnTaxRecord : false,
      }));
    },
    loanLabel() {
      const countyName = (this.globalSettingItem || {}).countyName || '';
      if (isTulsa(countyName)) {
        return 'Warrant No.';
      }
      return 'Loan No.';
    },
    checkIfItsTmAdmin() {
      // only show the button if the user is a super admin
      const isSuperAdmin = isAuthorised(authRoles.SuperAdmin);
      return isSuperAdmin || false;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
      'setIndex',
      'setIsVisible',
    ]),
    ...mapMutations('tax/taxInquires', [
      'setIsTaxIdClicked',
    ]),
    ...mapActions('tax/taxInquires', [
      'upsertTaxInquiryFixAmounts',
    ]),
    amountFormat,
    isItExemptManufacturing() {
      return (this.editedItem.statusCode || []).includes(exemptManufacturingStatusCode);
    },
    penaltyCaclFunc(val) {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(() => {
        const { penaltyDate, penaltyRate } = this.taxSettingItem;
        const {
          totalTax, totalPaid, penaltyStartDate, totalFee, taxYear, totalDue, _id, statusCode,
        } = this.editedItem;
        const isExemptManufacturing = (statusCode || []).includes(exemptManufacturingStatusCode);
        const itemFeeData = this.feeListBasedInIds;
        let totalFees = totalFee;
        if (itemFeeData.length && !isExemptManufacturing) {
          // to get fee based on effective date
          const feeList = itemFeeData.filter((ft) => ft.taxMongoId === _id);
          totalFees = taxFeeCheckWitheEfectiveDate(feeList, val);
        }
        const returnedVal = penaltyCalculation(
          val, penaltyStartDate, penaltyDate, totalTax,
          totalPaid, totalFees, penaltyRate, totalDue, taxYear, (statusCode || []),
          this.taxSettingItem,
        );
        this.editedItem.feesAndPen = amountFormat(totalDue
         + amountToNumber(returnedVal.penaltyWithOrWithoutFees));
        this.editedItem.getPenRateWithMonths = returnedVal.getPenRateWithMonths;
        this.editedItem.penaltyAmount = returnedVal.penaltyAmt;
        this.editedItem.totalFee = isExemptManufacturing ? 0 : totalFees;
      }, SEARCH_DEBOUNCE_TIMER);
    },
    openConfirmPopUp(fromWhere) {
      // to check its a paid record or not
      if ((amountToNumber(this.editedItem.totalDue) === 0)
      && !!this.editedItem._id && !!this.editedItem.totalTax) {
        if (fromWhere === 'continue') {
          this.showOrHidePopUp = false;
          this.openGeneralDetailsDialog();
        } else if (fromWhere === 'Cancel') this.showOrHidePopUp = false;
        else this.showOrHidePopUp = true;
      } else this.openGeneralDetailsDialog();
    },
    openGeneralDetailsDialog() {
      if (this.editedItem.taxId && this.editedItem.taxYear) this.$refs.newItem.handleFeeNewItem();
    },
    upsertItem() {
      this.statusDialog = false;
      const statusCode = this.selectedStatusCodes.filter((code) => code !== null
       && code !== undefined);
      this.editedItem.statusCode = statusCode;
      this.$emit('upsertItem', true, true);
    },
    dataFromCommonDropDowns(val, whichField) {
      if (whichField === 'statusCode') this.selectedStatusCodes = val;
      else this.editedItem[whichField] = val;
    },
    onTaxIdClick() {
      // The Tax ID box is readonly rather than disabled on a saved record now, so this click
      // handler can fire where a disabled input swallowed it. Keep it to the new-record case it
      // was written for, so merely reading an existing record does not trip the timer watcher
      // in CommonActionButtons.
      if (this.editedItem._id) return;
      this.setIsTaxIdClicked(true);
    },
    getCommentText(comment) {
      const comCreateDt = comment && comment.createdAt ? toShortDate(comment.createdAt) : '';
      const comText = comment && comment.comment ? comment.comment : '';
      const comTextLength = comText.length > 25 ? `${comText.substring(0, 25)}...` : comText;
      return `${comCreateDt} : ${comTextLength}`;
    },
    formatToPidWithDashes(val) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const formattedPid = pIdFormat(this.editedItem[val], formatPidPositions);
      this.editedItem[val] = formattedPid;
    },
    formatToPidWith(val) {
      // Property/Parcel ID is readonly rather than disabled for non tax-admins now, so a plain
      // click still focuses it and fires this. Stripping the dashes out of a box the user cannot
      // edit would leave the value unformatted if the form closes before blur. Only the focus
      // direction is gated; the @blur formatter is the display formatter and stays open.
      if (val === 'propertyOrParcelId' && this.checkTheUserIsTaxAdmin) return;
      const formatedPid = (this.editedItem[val]).replace(/-/g, '');
      this.editedItem[val] = formatedPid;
    },
    situsAddressFunc() {
      // Tulsa shows the unit/lot only on mobile home records, as '#<suffix>' (matches the saved address).
      const suffix = isTulsa((this.globalSettingItem || {}).countyName)
        ? getTulsaSitusSuffix(this.editedItem.taxType, this.editedItem.situsSuffix)
        : this.editedItem.situsSuffix;
      const {
        situsStreetNumber, situsStreetDirection, situsStreetName, situsStreetType, situsTown,
      } = this.editedItem;
      return [situsStreetNumber, situsStreetDirection, situsStreetName, situsStreetType, suffix, situsTown]
        .filter(Boolean).join(' ');
    },
    statusDialogFunc() {
      this.statusDialog = true;
      this.selectedStatusCodes = this.editedItem.statusCode;
    },
    async handleFixAmounts() {
      const item = {
        taxId: this.editedItem.taxId,
        taxYear: this.editedItem.taxYear,
        totalTax: this.editedItem.totalTax,
        penaltyStartDate: this.editedItem.penaltyStartDate
          ? toIsoDate(this.editedItem.penaltyStartDate)
          : null,
        statusCode: this.editedItem.statusCode,
        totalFee: this.editedItem.totalFee,
      };
      const result = await this.upsertTaxInquiryFixAmounts({
        item,
        baseCrudKey: this.baseCrudKey,
        postProcessTrans: this.taxPostProcessTrans,
      });
      const filterCurrentItem = (result || []).filter((ft) => ft._id === this.editedItem._id)[0]
       || {};
      // don't update the current item, just update the totalPaid, totalDue, and feesAndPen fields
      this.setItem([this.baseCrudKey, {
        ...this.editedItem,
        totalPaid: filterCurrentItem.totalPaid,
        totalDue: filterCurrentItem.totalDue,
        feesAndPen: filterCurrentItem.feesAndPen,
      }]);
    },
    taxPostProcessTrans(items) {
      const criteriaState = this.criteria(this.baseCrudKey) || {};
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const updatedItems = taxCommonPostProcessTrans(items,
        this.todaysDate, this.taxSettingItem, ((criteriaState || {}).penaltyDateValue || ''),
        formatPidPositions);
      return updatedItems;
    },
  },
};
</script>
<style scoped>
/* The read-only wrapper must be invisible: a bare <fieldset> ships a border, margin and
   padding that would reflow the whole Tax Info tab for everyone, view-only or not. */
.tax-general-details-fieldset {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}
.comments-card{
  height: 130px;
  overflow: scroll;
}
.clamp-2-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.status-codes-outlined {
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  min-height: 60px;
  max-height: 100px;
  padding: 12px;
  overflow-y: auto;
}
.status-code-line {
  line-height: 1.4;
  margin-bottom: 2px;
}
</style>
